module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/51nlPF/tc-custom/9781459261426.jpg?1718183455219",
      "alt": "This image is the cover for the book Warrior's Passion"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Warrior's Passion\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_c('i', [_vm._v("A Man of Power, Patience and Passion")])]), _c('br'), _c('br'), _c('i', [_vm._v("Power")]), _vm._v(" When Griffydd DeLanyea departed his ship in Dunloch, he thought his stay would last no more than a fortnight. Unbeknownst to Griffydd, Diarmad MacMurdock, the man he had come to see, was not merely interested in a trade alliance."), _c('br'), _c('br'), _c('i', [_vm._v("Patience")]), _vm._v(" Griffydd always believed that good things came to those who waited, but the Welshman had never wanted anything as badly as he wanted Diarmad's daughter Seona."), _c('br'), _c('br'), _c('i', [_vm._v("Passion")]), _vm._v(" Whether in battle or in love, Griffydd preferred to guard his feelings carefully. But the day would come when Seona would be his wife.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Margaret Moore\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Margaret Moore actually began her writing career at the age of eight, when she and a friend would make up stories together. She also loved to read and many years later graduated with a Bachelor of Arts degree in English Literature. After reading a romance by Kathleen Woodiwiss, Margaret took a course in popular fiction writing and through that, found Romance Writers of America. Three years later, in 1991, she sold her first historical romance. And the rest, as they say, is history!")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0